import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getUserById } from "../api/api";
import { environment } from "../../environments/environments";
import "../DocumentVerification/DocumentVerification.css";
import bgImage from "../../assets/images/brown-background.jpg";

const DocumentVerification = () => {
  const navigate = useNavigate();
  const [userdata, setUserdata] = useState("");
  const [refreshing, setRefreshing] = useState(false);

  useEffect(() => {
    getUserdata();
  }, []);

  const getUserdata = async () => {
    setRefreshing(true);
    try {
      const userData = localStorage.getItem("currentUser");
      console.log("userData11", userData);
      if (userData) {
        const parsedUserData = JSON.parse(userData);
        const _id = parsedUserData?.id || parsedUserData?._id;
        const currentUser = await getUserById({ user_id: _id });
        console.log(
          "getUserById in Confirm Modal Page",
          JSON.stringify(currentUser)
        );
        setUserdata(currentUser);
        if (
          currentUser?.data?.approve_reject_new_image === "approved" ||
          currentUser?.data?.approve_reject_new_image === "rejected"
        ) {
          navigate("/Sidebar");
        }
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
      navigate("/login-create-accounts");
    } finally {
      setRefreshing(false);
    }
  };

  const onRefresh = useCallback(() => {
    getUserdata();
  }, []);
  const handleLogout = () => {
    localStorage.removeItem("currentUser");
    navigate("/Login");
  };

  return (
    <div
      className="finalsubmission-container"
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="finalsubmission-card">
        <h1>Profile in Review</h1>
        <p className="finalsubmission-text">
          Your new profile picture is under review. You can continue browsing
          but cannot initiate or receive connections until it's approved.
        </p>
        <p className="finalsubmission-text margin-top">
          For other inquiries, please send an email to{" "}
          <span className="finalemail-text">info@connecttovow.com.</span>
        </p>
        <div className="finalSubmissionBtn">
          <button onClick={onRefresh} className="finalrefresh-btn">
            {refreshing ? "Refreshing status..." : "Refresh status"}
          </button>
          <button onClick={handleLogout} className="LogOut-btn">
            LogOut
          </button>
        </div>
      </div>
    </div>
  );
};

export default DocumentVerification;
